import { useMemo } from 'react';
import { Provider } from '../components/category/types';

interface UseCategoryFiltersProps {
  providers: Provider[];
  categoryId: string;
  sortBy: 'rating' | 'name' | 'experience';
  filterVerified: boolean;
  filterPremium: boolean;
}

export const useCategoryFilters = ({
  providers,
  categoryId,
  sortBy,
  filterVerified,
  filterPremium
}: UseCategoryFiltersProps) => {
  const filteredProviders = useMemo(() => {
    let filtered = providers.filter(provider => provider.category === categoryId);
    
    if (filterVerified) {
      filtered = filtered.filter(provider => provider.isVerified);
    }
    
    if (filterPremium) {
      filtered = filtered.filter(provider => provider.isPremium);
    }
    
    // Ordenar proveedores
    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'rating':
          return b.rating - a.rating;
        case 'name':
          return a.name.localeCompare(b.name);
        case 'experience':
          return b.yearsOfExperience - a.yearsOfExperience;
        default:
          return 0;
      }
    });
    
    return filtered;
  }, [providers, categoryId, sortBy, filterVerified, filterPremium]);

  return filteredProviders;
};
